import axiosInstance from '@/shared/api/axios';
import type {
  ApiTrackedList,
  ApiTrackedSaveBody,
  ApiTrackedItem,
  ApiTrackResult,
} from '@/shared/types/api/tracking';

export const apiTrackLookup = async (trekId: string): Promise<ApiTrackResult> => {
  const { data } = await axiosInstance.get<ApiTrackResult>('/track', {
    params: { trek_id: trekId },
  });
  return data;
};

export const apiTrackedList = async (): Promise<ApiTrackedList> => {
  const { data } = await axiosInstance.get<ApiTrackedList>('/track/saved');
  return data;
};

export const apiTrackedSave = async (body: ApiTrackedSaveBody): Promise<ApiTrackedItem> => {
  const { data } = await axiosInstance.post<ApiTrackedItem>('/track/saved', body);
  return data;
};

export const apiTrackedDelete = async (trekId: string): Promise<void> => {
  await axiosInstance.delete('/track/saved', { params: { trek_id: trekId } });
};
